import { MockDatabase, MockRecord, MockTable, TableQuery } from "../MockDatabase";

export class MockCDN extends MockTable {
    constructor(db: MockDatabase) {
        super(db);
        this.name = 'cdn';
        this.fields = {
            id: this.PrimaryKey({
                fieldName: 'id'
            }),
            bundle_id: this.ForeignKey({
                fieldName: 'bundle_id',
                nullable: false,
                index: true,
                foreignTableName: 'bundles',
                foreignTableFieldName: 'id',
            }),
            filepath: this.Field({
                type: 'string',
                fieldName: 'file_path',
                nullable: false,
                index: true
            }),
            file: this.Field({
                type: 'blob',
                fieldName: 'file',
                nullable: false
            })
        }
    }

    private _transformPayload(db: MockDatabase, values: Record<string, any>): Record<string, any> {
        let {
            bundle_guid, bundleGuid, bundle_id,
            ...data
        } = values;
        if ((bundle_guid || bundleGuid) && !bundle_id) {
            bundle_id = db.resolveGuidToId('bundles', (bundle_guid || bundleGuid));
        }
        return {
            ...data,
            ...(bundle_id ? { bundle_id } : {}),
        }
    }

    protected beforeQuery: (db: MockDatabase, table: MockTable, query: TableQuery) => TableQuery = (db, table, query) => {
        const transFormFields: Record<string, any> = {};
        const remQuery: TableQuery = [];
        query.forEach(entry => {
            if (entry.fieldName === 'bundle_guid' || entry.fieldName === 'bundleGuid') {
                transFormFields['bundle_guid'] = entry.value;
            } else {
                remQuery.push(entry);
            }
        });
        const fixed = this._transformPayload(db, transFormFields);
        Object.entries(fixed).forEach(([fieldName, value]) => remQuery.unshift({
            fieldName,
            value
        }));
        return remQuery;
    }

    protected beforeUpdate: (db: MockDatabase, table: MockTable, records: MockRecord[], data: Record<string, any>) => Record<string, any> = (db, table, records, data) => {
        return this._transformPayload(db, data);
    }

    protected beforeCreate: (db: MockDatabase, table: MockTable, values: Record<string, any>) => Record<string, any> = (db, table, values) => {
        return this._transformPayload(db, values);
    }

    serialize: (record: MockRecord) => Blob = (record: MockRecord) => record.values['file']

    serializeList: (records: MockRecord[]) => string[] = (records: MockRecord[]) => records.map(record => record.values['filepath'])
}